import { useEffect, useRef } from 'preact/hooks'
import SwiperInstanceComponent from 'customs/swiper-instance-component'
import Icon from 'snippets/icon/icon'

export default function CarouselSwiper({
  children,
  classWrapper,
  className,
  classNavigation,
  selector,
  options,
  classIcon = 'size-5',
  navigation = false,
  pagination = false,
  scrollbar = true,
  keyboard = false,
  thumbnail = null,
  zoom = false,
  mousewheel = false,
  freeMode = false,
  paginationTypeNumber = false,
  setCarouselInstance = () => {}
}) {
  const config = { navigation, pagination, scrollbar, keyboard, thumbnail, zoom, mousewheel, freeMode }
  const swiperRef = useRef(null)

  useEffect(() => {
    const currentOptions = {
      ...options,
      on: {
        init: () => {
          swiperRef.current.classList.add('swiper-initialized')
        },
        afterInit: (swiper) => {
          setCarouselInstance(swiper)
        },
        ...(options?.on || {})
      }
    }

    // eslint-disable-next-line no-unused-vars
    const carouselInstance = new SwiperInstanceComponent(swiperRef.current, currentOptions, config, 'component')
  }, [])

  return (
    children && (
      <div
        className={`swiper-wrapper h-full ${classWrapper}`}
        ref={swiperRef}
        data-selector={selector}
        data-type="component"
      >
        {navigation && (
          <div className={`ml-auto flex items-center gap-2 ${classNavigation}`}>
            <button className="swiper-button-prev js-carousel-prev" type="button" aria-label="Previous slide">
              <Icon name="icon-chevron-left" className={classIcon} viewBox="0 0 20 20" />
            </button>
            {pagination && paginationTypeNumber && <div class="swiper-pagination js-carousel-pagination" />}
            <button className="swiper-button-next js-carousel-next" type="button" aria-label="Next slide">
              <Icon name="icon-chevron-right" className={classIcon} viewBox="0 0 20 20" />
            </button>
          </div>
        )}
        <swiper-container className={`swiper ${className} ${selector}`} init="false">
          {children}
        </swiper-container>
        {pagination && !paginationTypeNumber && <div className="swiper-pagination js-carousel-pagination" />}
        {scrollbar && <div className="swiper-scrollbar js-carousel-scrollbar" />}
      </div>
    )
  )
}
